export const RESET = 'EXSBDOCUMENTTYPE_UPDATE_RESET'
export const SET_ERROR = 'EXSBDOCUMENTTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBDOCUMENTTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBDOCUMENTTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBDOCUMENTTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBDOCUMENTTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBDOCUMENTTYPE_UPDATE_UPDATE_RETRIEVED'
